import { useCallback, useState, useMemo } from 'react';
import { Select } from '@shared/inputs/Select';
import { CopyButton } from '@styles/StyledButtons';
import { IOption, IPeriod } from '@shared/interfaces';
import { TeamManagerColumn, TeamManagerContent } from '@styles/Admin-tools/TeamManagerStyle';
import { requestCopyTeam } from './queries';

interface ITeamTypesProps {
  periods: IPeriod[];
}

export const CopyTeams = ({ periods }: ITeamTypesProps) => {
  const [oldPeriodId, setOldPeriodId] = useState<string>('');
  const [newPeriodId, setNewPeriodId] = useState<string>('');

  const periodsOptions: IOption[] = useMemo(
    () =>
      periods.map((period) => ({
        value: period.id,
        label: period.name,
      })),
    [periods],
  );

  const handleCopyTeam = useCallback(() => {
    if (oldPeriodId && newPeriodId) {
      return requestCopyTeam({
        oldPeriodId,
        newPeriodId,
      });
    }
  }, [oldPeriodId, newPeriodId]);

  return (
    <TeamManagerContent>
      <TeamManagerColumn>
        <Select
          label="From Period"
          value={oldPeriodId}
          options={periodsOptions}
          placeholder="Select Period..."
          onChange={setOldPeriodId}
        />
      </TeamManagerColumn>

      <TeamManagerColumn>
        <Select
          label="To Period"
          value={newPeriodId}
          options={periodsOptions}
          placeholder="Select Period..."
          onChange={setNewPeriodId}
        />
      </TeamManagerColumn>

      <CopyButton variant="contained" disabled={!oldPeriodId || !newPeriodId} onClick={handleCopyTeam}>
        Copy
      </CopyButton>
    </TeamManagerContent>
  );
};
